import type { DividerRecord } from '@/types/datocms-schema'

import type { GridRecord } from '@/components/blocks/DesignSystem/Grid'
import type { GridBlockRecord } from '@/components/blocks/DesignSystem/GridBlock'
import type { VideoCoverRecord } from '@/components/blocks/DesignSystem/VideoCoverBlock'
import type { PdpSectionRecord } from '@/components/blocks/marketingBlocks/PdpSection'
import type { LinkCollectionRecord } from '@/components/blocks/ModularLandingPage/LinkCollectionBlock'
import type { MediaAndTextRecord } from '@/components/blocks/ModularLandingPage/MediaAndTextBlock'
import type { AppDownloadSectionRecord } from '@/components/blocks/Shared/AppDownloadBlock'
import type { CardsSectionRecord } from '@/components/blocks/Shared/CardsBlock'
import type { ContentAndImageBlockRecord } from '@/components/blocks/Shared/ContentAndImageBlock'
import type { FullWidthMediaAssetRecord } from '@/components/blocks/Shared/FullWidthMediaAssetBlock'
import type { FullWidthTextRecord } from '@/components/blocks/Shared/FullWidthTextBlock'
import type { InfoSurfaceBlockRecord } from '@/components/blocks/Shared/InfoSurfaceBlock'
import type { JumboTitleRecord } from '@/components/blocks/Shared/JumboTitleBlock'
import type { PodcastBlockRecord } from '@/components/blocks/Shared/PodcastBlock'
import type { SwipeCardsSectionRecord } from '@/components/blocks/Shared/SwipeCardsBlock'
import type { VideoFullWidthRecord } from '@/components/blocks/Shared/VideoFullWidthBlock'

import { renderModularBlocks } from '../renderModularBlocks'

export type ModularLandingPageContentBlocks =
  | JumboTitleRecord
  | MediaAndTextRecord
  | FullWidthMediaAssetRecord
  | FullWidthTextRecord
  | LinkCollectionRecord
  | CardsSectionRecord
  | AppDownloadSectionRecord
  | VideoFullWidthRecord
  | VideoCoverRecord
  | DividerRecord
  | ContentAndImageBlockRecord
  | InfoSurfaceBlockRecord
  | PodcastBlockRecord
  | SwipeCardsSectionRecord
  | GridRecord
  | GridBlockRecord
  | PdpSectionRecord

type ModularLandingPageContentProps = {
  content: ModularLandingPageContentBlocks[]
}

export const ModularLandingPageContent = ({ content }: ModularLandingPageContentProps) => {
  return <>{(content ?? []).map((record, index) => renderModularBlocks(record, index))}</>
}
